<div class="page" [ngClass]="{'activeCmpt' : !modoEstandar}">

  <div class="header">
    <div class="titleClock">
      <h1 class="text-nowrap">GESTIÓN DE JORNADA</h1>

      <div class="reloj">{{horaActual}}</div>

      <div class="indic" [ngClass]="{'active' : indicadores}">
        <div class="ico d-flex d-md-none"><img src="assets/img/icoIndicadores.svg"></div>
        <div class="label d-none d-md-block">INDICADORES</div>
        <div class="switch" (click)="indicadores = !indicadores">
          <span></span>
        </div>
      </div>

      <div class="modo" (click)="modoEstandar = !modoEstandar" [ngClass]="{'activeCmpt' : !modoEstandar}">
        <div class="but">ESTANDAR</div>
        <div class="but">COMPACTO</div>
      </div>
    </div>

    <div class="terminal" [tooltip]="sucursalesSelectedNombresLargos">
      <p><strong>TERMINAL:</strong>{{sucursalesSelectedNombres}}</p>
      <button class="btn btnBlack" (click)="openModalCambiarSucursal()">CAMBIAR</button>
    </div>
  </div>


  <div class="indicadores" [ngClass]="{'sinInd' : !indicadores}">
    <div class="contBoxes">
      <div *ngFor="let kpi of listaKPis" class="box" [ngClass]="{'active': kpiSelected?.codigo == kpi.codigo}"
        [style.background-color]="kpi.colorFondo" (click)="filtrarPorKPI(kpi)" [tooltip]="kpi.descripcion"
        placement="bottom" container="body">
        <span [style.color]="kpi.colorLetra">{{kpi.tituloPantalla}}</span>
        <h1 [style.color]="kpi.colorLetra">{{kpi.valor}}</h1>
      </div>
    </div>
  </div>

  <div class="boxWhite" [ngClass]="{'sinInd' : !indicadores}">
    <div class="headBox">
      <div class="filtros">
        <div class="buscar itemForm">
          <input type="search" class="form-control" placeholder="Buscar Conductor..."
            (input)="onInputConductor($event)">
        </div>
        <div class="fecha itemForm d-lg-block d-none">
          <input type="text" class="form-control" placeholder="Desde" bsDatepicker
            (bsValueChange)="onChangeDesde($event)" [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}"
            [bsValue]="searchDesde">
        </div>
        <div class="fecha itemForm d-lg-block d-none">
          <input type="text" class="form-control" placeholder="Hasta" bsDatepicker
            (bsValueChange)="onChangeHasta($event)" [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}"
            [bsValue]="searchHasta">
        </div>

        <div class="select itemForm d-lg-block d-none" [tooltip]="getEstadosSeleccionados()">
          <ng-select class="select select-width" placeholder="Estado" [(ngModel)]="estado"
            (change)="changeEstadoFiltro()" [multiple]="true" appendTo="body" [closeOnSelect]="false">
            <ng-template ng-multi-label-tmp let-items="items">
              <span style="display:block; font-size: 13px; top: 7px;color: var(--black)" class="ng-placeholder"
                *ngIf="items.length > 1">{{items.length}} Seleccionados</span>
              <span style="display:block; font-size: 13px; top: 7px; color: var(--black)" class="ng-placeholder"
                *ngIf="items.length == 1">{{ESTADOS_GESTION_JORNADA[items[0]]}}</span>
            </ng-template>

            <ng-option [value]="key" *ngFor="let key of objectKeys(ESTADOS_GESTION_JORNADA)">
              {{ESTADOS_GESTION_JORNADA[key]}}
            </ng-option>
          </ng-select>
        </div>

        <button class="ms-auto btn btnFilter d-lg-none d-block" (click)="filtroColap = !filtroColap">
          <img src="assets/img/icoFiltro.svg">
        </button>
      </div>


      <div class="d-flex mt-xl-0 mt-3 align-items-center justify-content-lg-start justify-content-between gap-2">
        <div class="btnSync">
          <div class="ico" (click)="reload()" [tooltip]="'Recargar datos'">
            <img src="assets/img/icoRefresh.svg" alt="">
          </div>
          <ng-select class="selectNg" placeholder="Recargar cada..." [(ngModel)]="recarga" (change)="calcularTime()"
            (clear)="recarga = optionRecargas[0]; calcularTime()" appendTo="body">

            <ng-option [value]="opcion" *ngFor="let opcion of optionRecargas">{{opcion.label}}</ng-option>
          </ng-select>
          <div class="barra" *ngIf="recarga?.value != 0">
            <progressbar [max]="recarga?.value/1000" [value]="contador/1000" [animate]="true" [striped]="true">
            </progressbar>
          </div>
        </div>

        <button class="btn btnOrange" *ngIf="tienePermisoCrearJornada()" (click)="crearJornada()">CREAR JORNADA</button>
      </div>


    </div>

    <div class="tableResp" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="150"
      (scrolled)="onScroll()" [scrollWindow]="false" [alwaysCallback]="false"
      [infiniteScrollDisabled]="desactivarInfiniteScroll">
      <table class="table">
        <thead>
          <tr>
            <th [tooltip]="'ID del conductor'" placement="bottom" container="body">ID CB</th>
            <th [tooltip]="'Nombre del conductor'" placement="bottom" container="body">NOMBRES</th>
            <th [tooltip]="'Estado de la jornada'" placement="bottom" container="body">ESTADO</th>
            <!--<th>H. PPT. REAL</th>-->
            <th [tooltip]="'Inicio planificado / real'" placement="bottom" container="body">INICIO</th>
            <th [tooltip]="'Tipo de jornada'" placement="bottom" container="body">TIPO JORNADA</th>
            <th [tooltip]="'Horas asignadas'" placement="bottom" container="body">H. ASIGNADAS</th>
            <th [tooltip]="'Término de jornada planificado / real'" placement="bottom" container="body">TÉRMINO J.</th>
            <th [tooltip]="'Acciones de la jornada'" placement="bottom" container="body">ACCIÓN</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let jornada of listaJornadas"
            [ngClass]="{'alerta-tr': jornada.estado == 'ATRASADA', 'alerta-gray': listaUuidJornadasRecienCreadas.includes(jornada.uuid)}">
            <td>{{jornada.conductor.visibleId}}</td>
            <td>{{jornada.conductor.nombres}} {{jornada.conductor.apellidoPaterno}}</td>
            <td>{{estadosService.transformGestionJornadaEstado(jornada?.estado)}}</td>
            <!--<td>XXX -- XXX</td>-->
            <td>{{muestraTiempoRelativo(jornada.fechaInicioPlanificado)}} /
              {{muestraTiempoRelativo(jornada.fechaHoraInicio)}}</td>
            <td>{{jornada.conductor?.tipoContrato?.replace('_', ' ')}}</td>
            <td>{{muestraHorasAsignadas(jornada.minutosJornada)}}</td>
            <td>{{muestraTiempoRelativo(jornada.fechaTerminoPlanficiado)}} /
              {{muestraTiempoRelativo(jornada.fechaHoraTermino)}}</td>
            <td>
              <div class="btns">
                <span *ngIf="tienePermisoCambiarSucursalCB()" [tooltip]="'Cambiar terminal'">
                  <button class="btn btnTerminal" [disabled]="esJornadaBloqueada(jornada)"
                    (click)="openModalCambiarSucursalCB(jornada)"><img src="assets/img/icoTerminal.svg" alt=""></button>
                </span>
                <span *ngIf="!jornada.fechaHoraInicio && tienePermisoIniciarJornada()" [tooltip]="'Iniciar jornada'">
                  <button class="btn btnIniciar" [disabled]="esJornadaBloqueada(jornada)"
                    (click)="iniciarJornada(jornada)"><img src="assets/img/icoIniciarJornada.svg" alt=""></button>
                </span>
                <span *ngIf="tienePermisoEditarJornada()" [tooltip]="'Editar jornada'">
                  <button class="btn btnEditar" [disabled]="esJornadaBloqueada(jornada)"
                    (click)="editarJornada(jornada)"><img src="assets/img/icoEditJornada.svg" alt=""></button>
                </span>
                <span *ngIf="tienePermisoImprimirPlanilla()" [tooltip]="'Imprimir planilla'">
                  <button class="btn btnImprimir" (click)="getInicioJornadaPDF(jornada)" [disabled]="procesandoPdf"><img
                      src="assets/img/icoPrint.svg" alt=""></button>
                </span>
                <span *ngIf="tienePermisoCancelarJornada()" [tooltip]="'Cancelar jornada'">
                  <button class="btn btnCancelar" [disabled]="esJornadaBloqueada(jornada)"
                    (click)="cancelarJornada(jornada)"><img src="assets/img/icoCancel.svg" alt=""></button>
                </span>
                <span
                  *ngIf="jornada.conductor?.estado === 'FUERA_JORNADA' && jornada.estado == 'FINALIZADA' && isFechaTerminoRangoValidoDeshacerFinJornada(jornada) && tienePermisoDeshacerFinJornada()"
                  [tooltip]="'Deshacer fin de jornada'">
                  <button class="btn btnDeshacer"><img src="assets/img/icoDeshacer.svg" alt=""
                      (click)="deshacerFinJornada(jornada.conductor)"></button>
                </span>
              </div>
            </td>
          </tr>
          <!--<tr>
            <td>7531</td>
            <td>ELIO NILO</td>
            <td>Por Presentarse</td>
            <td>--</td>
            <td>Hoy, 08:45</td>
            <td>Full Time</td>
            <td>8h</td>
            <td>--</td>
            <td>
              <div class="btns">
                <button class="btn btnTerminal"><img src="assets/img/icoTerminal.svg" alt=""></button>
                <button class="btn btnIniciar" (click)="iniciarJornada()"><img src="assets/img/icoIniciarJornada.svg" alt=""></button>
                <button class="btn btnEditar" (click)="editarJornada()"><img src="assets/img/icoEditJornada.svg" alt=""></button>
                <button class="btn btnImprimir"><img src="assets/img/icoPrint.svg" alt=""></button>
                <button class="btn btnCancelar"><img src="assets/img/icoCancel.svg" alt=""></button>
              </div>
            </td>
          </tr>

          <tr>
            <td>7531</td>
            <td>ELIO NILO</td>
            <td>Por Presentarse</td>
            <td>--</td>
            <td>Hoy, 08:45</td>
            <td>Full Time</td>
            <td>8h</td>
            <td>--</td>
            <td>
              <div class="btns">
                <button class="btn btnTerminal"><img src="assets/img/icoTerminal.svg" alt=""></button>
                <button class="btn btnIniciar"><img src="assets/img/icoIniciarJornada.svg" alt=""></button>
                <button class="btn btnEditar"><img src="assets/img/icoEditJornada.svg" alt=""></button>
                <button class="btn btnImprimir"><img src="assets/img/icoPrint.svg" alt=""></button>
                <button class="btn btnCancelar"><img src="assets/img/icoCancel.svg" alt=""></button>
              </div>
            </td>
          </tr>
          <tr>
            <td>7531</td>
            <td>ELIO NILO</td>
            <td>Por Presentarse</td>
            <td>--</td>
            <td>Hoy, 08:45</td>
            <td>Full Time</td>
            <td>8h</td>
            <td>--</td>
            <td>
              <div class="btns">
                <button class="btn btnTerminal"><img src="assets/img/icoTerminal.svg" alt=""></button>
                <button class="btn btnIniciar"><img src="assets/img/icoIniciarJornada.svg" alt=""></button>
                <button class="btn btnEditar"><img src="assets/img/icoEditJornada.svg" alt=""></button>
                <button class="btn btnImprimir"><img src="assets/img/icoPrint.svg" alt=""></button>
                <button class="btn btnCancelar"><img src="assets/img/icoCancel.svg" alt=""></button>
              </div>
            </td>
          </tr>
          <tr>
            <td>7531</td>
            <td>ELIO NILO</td>
            <td>Por Presentarse</td>
            <td>--</td>
            <td>Hoy, 08:45</td>
            <td>Full Time</td>
            <td>8h</td>
            <td>--</td>
            <td>
              <div class="btns">
                <button class="btn btnTerminal"><img src="assets/img/icoTerminal.svg" alt=""></button>
                <button class="btn btnIniciar"><img src="assets/img/icoIniciarJornada.svg" alt=""></button>
                <button class="btn btnEditar"><img src="assets/img/icoEditJornada.svg" alt=""></button>
                <button class="btn btnImprimir"><img src="assets/img/icoPrint.svg" alt=""></button>
                <button class="btn btnCancelar"><img src="assets/img/icoCancel.svg" alt=""></button>
              </div>
            </td>
          </tr>
          <tr>
            <td>7531</td>
            <td>ELIO NILO</td>
            <td>Por Presentarse</td>
            <td>--</td>
            <td>Hoy, 08:45</td>
            <td>Full Time</td>
            <td>8h</td>
            <td>--</td>
            <td>
              <div class="btns">
                <button class="btn btnTerminal"><img src="assets/img/icoTerminal.svg" alt=""></button>
                <button class="btn btnIniciar"><img src="assets/img/icoIniciarJornada.svg" alt=""></button>
                <button class="btn btnEditar"><img src="assets/img/icoEditJornada.svg" alt=""></button>
                <button class="btn btnImprimir"><img src="assets/img/icoPrint.svg" alt=""></button>
                <button class="btn btnCancelar"><img src="assets/img/icoCancel.svg" alt=""></button>
              </div>
            </td>
          </tr>
          <tr>
            <td>7531</td>
            <td>ELIO NILO</td>
            <td>Por Presentarse</td>
            <td>--</td>
            <td>Hoy, 08:45</td>
            <td>Full Time</td>
            <td>8h</td>
            <td>--</td>
            <td>
              <div class="btns">
                <button class="btn btnTerminal"><img src="assets/img/icoTerminal.svg" alt=""></button>
                <button class="btn btnIniciar"><img src="assets/img/icoIniciarJornada.svg" alt=""></button>
                <button class="btn btnEditar"><img src="assets/img/icoEditJornada.svg" alt=""></button>
                <button class="btn btnImprimir"><img src="assets/img/icoPrint.svg" alt=""></button>
                <button class="btn btnCancelar"><img src="assets/img/icoCancel.svg" alt=""></button>
              </div>
            </td>
          </tr>
          <tr>
            <td>7531</td>
            <td>ELIO NILO</td>
            <td>Por Presentarse</td>
            <td>--</td>
            <td>Hoy, 08:45</td>
            <td>Full Time</td>
            <td>8h</td>
            <td>--</td>
            <td>
              <div class="btns">
                <button class="btn btnTerminal"><img src="assets/img/icoTerminal.svg" alt=""></button>
                <button class="btn btnIniciar"><img src="assets/img/icoIniciarJornada.svg" alt=""></button>
                <button class="btn btnEditar"><img src="assets/img/icoEditJornada.svg" alt=""></button>
                <button class="btn btnImprimir"><img src="assets/img/icoPrint.svg" alt=""></button>
                <button class="btn btnCancelar"><img src="assets/img/icoCancel.svg" alt=""></button>
              </div>
            </td>
          </tr>
          <tr>
            <td>7531</td>
            <td>ELIO NILO</td>
            <td>Por Presentarse</td>
            <td>--</td>
            <td>Hoy, 08:45</td>
            <td>Full Time</td>
            <td>8h</td>
            <td>--</td>
            <td>
              <div class="btns">
                <button class="btn btnTerminal"><img src="assets/img/icoTerminal.svg" alt=""></button>
                <button class="btn btnIniciar"><img src="assets/img/icoIniciarJornada.svg" alt=""></button>
                <button class="btn btnEditar"><img src="assets/img/icoEditJornada.svg" alt=""></button>
                <button class="btn btnImprimir"><img src="assets/img/icoPrint.svg" alt=""></button>
                <button class="btn btnCancelar"><img src="assets/img/icoCancel.svg" alt=""></button>
              </div>
            </td>
          </tr>
          <tr>
            <td>7531</td>
            <td>ELIO NILO</td>
            <td>Por Presentarse</td>
            <td>--</td>
            <td>Hoy, 08:45</td>
            <td>Full Time</td>
            <td>8h</td>
            <td>--</td>
            <td>
              <div class="btns">
                <button class="btn btnTerminal"><img src="assets/img/icoTerminal.svg" alt=""></button>
                <button class="btn btnIniciar"><img src="assets/img/icoIniciarJornada.svg" alt=""></button>
                <button class="btn btnEditar"><img src="assets/img/icoEditJornada.svg" alt=""></button>
                <button class="btn btnImprimir"><img src="assets/img/icoPrint.svg" alt=""></button>
                <button class="btn btnCancelar"><img src="assets/img/icoCancel.svg" alt=""></button>
              </div>
            </td>
          </tr>
          <tr>
            <td>7531</td>
            <td>ELIO NILO</td>
            <td>Por Presentarse</td>
            <td>--</td>
            <td>Hoy, 08:45</td>
            <td>Full Time</td>
            <td>8h</td>
            <td>--</td>
            <td>
              <div class="btns">
                <button class="btn btnTerminal"><img src="assets/img/icoTerminal.svg" alt=""></button>
                <button class="btn btnIniciar"><img src="assets/img/icoIniciarJornada.svg" alt=""></button>
                <button class="btn btnEditar"><img src="assets/img/icoEditJornada.svg" alt=""></button>
                <button class="btn btnImprimir"><img src="assets/img/icoPrint.svg" alt=""></button>
                <button class="btn btnCancelar"><img src="assets/img/icoCancel.svg" alt=""></button>
              </div>
            </td>
          </tr>
          <tr>
            <td>7531</td>
            <td>ELIO NILO</td>
            <td>Por Presentarse</td>
            <td>--</td>
            <td>Hoy, 08:45</td>
            <td>Full Time</td>
            <td>8h</td>
            <td>--</td>
            <td>
              <div class="btns">
                <button class="btn btnTerminal"><img src="assets/img/icoTerminal.svg" alt=""></button>
                <button class="btn btnIniciar"><img src="assets/img/icoIniciarJornada.svg" alt=""></button>
                <button class="btn btnEditar"><img src="assets/img/icoEditJornada.svg" alt=""></button>
                <button class="btn btnImprimir"><img src="assets/img/icoPrint.svg" alt=""></button>
                <button class="btn btnCancelar"><img src="assets/img/icoCancel.svg" alt=""></button>
              </div>
            </td>
          </tr>
          <tr>
            <td>7531</td>
            <td>ELIO NILO</td>
            <td>Por Presentarse</td>
            <td>--</td>
            <td>Hoy, 08:45</td>
            <td>Full Time</td>
            <td>8h</td>
            <td>--</td>
            <td>
              <div class="btns">
                <button class="btn btnTerminal"><img src="assets/img/icoTerminal.svg" alt=""></button>
                <button class="btn btnIniciar"><img src="assets/img/icoIniciarJornada.svg" alt=""></button>
                <button class="btn btnEditar"><img src="assets/img/icoEditJornada.svg" alt=""></button>
                <button class="btn btnImprimir"><img src="assets/img/icoPrint.svg" alt=""></button>
                <button class="btn btnCancelar"><img src="assets/img/icoCancel.svg" alt=""></button>
              </div>
            </td>
          </tr>-->

        </tbody>

      </table>
    </div>



  </div>


</div>


<div class="sideFiltros d-lg-none d-block" [ngClass]="{'colap' : !filtroColap}">

  <button class="btn btnClose" (click)="filtroColap = !filtroColap">
    <img src="assets/img/icoClose.svg" alt="">
  </button>
  <div class="title">Filtrar por:</div>

  <div class="fecha itemForm">
    <input type="text" class="form-control" placeholder="Desde" bsDatepicker (bsValueChange)="onChangeDesde($event)"
      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}" [bsValue]="searchDesde">
  </div>
  <div class="fecha itemForm">
    <input type="text" class="form-control" placeholder="Hasta" bsDatepicker (bsValueChange)="onChangeHasta($event)"
      [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}" [bsValue]="searchHasta">
  </div>

  <div class="select itemForm" [tooltip]="getEstadosSeleccionados()">
    <ng-select class="select select-width" placeholder="Estado" [(ngModel)]="estado" (change)="changeEstadoFiltro()"
      [multiple]="true" appendTo="body" [closeOnSelect]="false">
      <ng-template ng-multi-label-tmp let-items="items">
        <span style="display:block; font-size: 13px; top: 7px;color: var(--black)" class="ng-placeholder"
          *ngIf="items.length > 1">{{items.length}} Seleccionados</span>
        <span style="display:block; font-size: 13px; top: 7px; color: var(--black)" class="ng-placeholder"
          *ngIf="items.length == 1">{{ESTADOS_GESTION_JORNADA[items[0]]}}</span>
      </ng-template>

      <ng-option [value]="key"
        *ngFor="let key of objectKeys(ESTADOS_GESTION_JORNADA)">{{ESTADOS_GESTION_JORNADA[key]}}</ng-option>

    </ng-select>

  </div>

  <div class="buttons">
    <button class="btnBlack" (click)="filtroColap = !filtroColap">APLICAR FILTRO</button>
    <button class="btn btnClean">LIMPIAR FILTRO</button>
  </div>
</div>